var moduleMap = {
	"./DynamicChildViewWidget": () => {
		return Promise.all(/* __federation_expose_DynamicChildViewWidget */[__webpack_require__.e(3666), __webpack_require__.e(2535), __webpack_require__.e(1752), __webpack_require__.e(7212), __webpack_require__.e(2760), __webpack_require__.e(9069), __webpack_require__.e(8576), __webpack_require__.e(8816)]).then(() => (() => ((__webpack_require__(22703)))));
	},
	"./LinkedRecordsWidget": () => {
		return Promise.all(/* __federation_expose_LinkedRecordsWidget */[__webpack_require__.e(501), __webpack_require__.e(5886), __webpack_require__.e(7750), __webpack_require__.e(2590), __webpack_require__.e(899), __webpack_require__.e(3666), __webpack_require__.e(1286), __webpack_require__.e(4249), __webpack_require__.e(7212), __webpack_require__.e(2760), __webpack_require__.e(9069), __webpack_require__.e(8576), __webpack_require__.e(1635)]).then(() => (() => ((__webpack_require__(48086)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope, remoteEntryInitOptions) => {
	return __webpack_require__.federation.bundlerRuntime.initContainerEntry({	webpackRequire: __webpack_require__,
		shareScope: shareScope,
		initScope: initScope,
		remoteEntryInitOptions: remoteEntryInitOptions,
		shareScopeKey: "default"
	})
};
// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});